import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { Form } from 'react-bootstrap';

import PageHeader from '../../atoms/PageHeader';
import AtlasEditor from '../../components/AtlasEditor';
import Loading from '../../components/Loading';
import NotFound from '../NotFound';

const { isTierra2 } = Meteor.settings.public;

const NewAtlas = ({ history, loading, match, isBasic }) => {
  if (isTierra2) return <NotFound />;
  if (loading) return <Loading />;
  return (
    <Form style={{ margin: '15px' }}>
      <PageHeader>
        <h4>New Atlas</h4>
      </PageHeader>
      <AtlasEditor history={history} match={match} isBasic={isBasic} />
    </Form>
  );
};

NewAtlas.propTypes = {
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  isBasic: PropTypes.bool.isRequired
};

export default NewAtlas;
